import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './List.module.scss';
import { BRAND } from '../../constants/brand';

interface ListProps {
  className?: string;
}

const List: FunctionComponent<ListProps> = ({ children, className }) => {
  const listClass = classNames(`${BRAND.SUPER_SHORT_NAME}-list`, className, {
    [styles.list]: true,
  });

  return <ul className={listClass}>{children}</ul>;
};

export default List;
